import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { UtilDadosLogado } from './util.logado';
import { map } from 'rxjs/operators';

@Injectable()
export class UtilServico {
    //public sub = "http://localhost:62195/api/Inicial/";
    //public sub = "http://localhost/webapiportales/api/Inicial/";
    //public sub = "http://proxima.sisprevweb.com.br/webapiportales/api/Inicial/";
    //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Inicial/";
    //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipehomologacao/api/Inicial/";    
    constructor(private http: Http,private UtilDadosLogado:UtilDadosLogado) {        
     }
   
    Get(metodo: string) {
            return this.http.get(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/" + metodo, this.jwt()).pipe(
                map((res: Response) => res.json()));
    }

    Put(metodo: string, dados: any) {
        let body = JSON.stringify(dados);
            return this.http.put(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/" + metodo, body, this.jwt()).pipe(
                map((res: Response) => res.json()));
    }

    Post(metodo: string, dados: any) {
        let body = dados;
        return this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/" + metodo, body, this.jwt()).pipe(
            map((res: Response) => res.json()));
    }

    private jwt() {
        let dados = JSON.parse(localStorage.getItem('AcessoAdm'));
        if (dados && dados.TOKEN) {
            let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' ,'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS','Access-Control-Allow-Origin': '*', 'Authorization': 'Bearer ' + dados.TOKEN });
            return new RequestOptions({ headers: headers });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/servicos/util.servico.ts